import { ref, onMounted, onUnmounted } from "vue"

export function useBreakpoint() {
  const isMobile = ref(false)

  let mediaQuery

  const update = (e) => {
    isMobile.value = e.matches
  }

  onMounted(() => {
    mediaQuery = window.matchMedia("(max-width: 767px)")
    isMobile.value = mediaQuery.matches
    mediaQuery.addEventListener("change", update)
  })

  onUnmounted(() => {
    mediaQuery.removeEventListener("change", update)
  })

  return { isMobile }
}
